import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import type { TypeFaqItem } from "@/types/contentful/generated";

type FaqItemEntry = TypeFaqItem<undefined, string>;

export function buildFaqJsonLd(items: FaqItemEntry[]) {
  if (items.length === 0) return null;

  const mainEntity = items.map(item => ({
    "@type": "Question",
    name: item.fields.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: documentToHtmlString(item.fields.answer),
    },
  }));

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity,
  };
}
